import { useUI } from "../../lib/uiStore";
import { StatusDialogHost } from "../../components/StatusPicker";
import { CommandPalette } from "./CommandPalette";
import { QuickSwitcher } from "./QuickSwitcher";
import { ShortcutHelp } from "./ShortcutHelp";

/** Global overlays (one at a time), opened by shortcuts or the command palette. */
export function PaletteHost() {
  const overlay = useUI((s) => s.overlay);
  const setOverlay = useUI((s) => s.setOverlay);
  const toggle = (which: NonNullable<typeof overlay>) => (open: boolean) => setOverlay(open ? which : overlay === which ? null : overlay);
  return (
    <>
      <QuickSwitcher open={overlay === "switcher"} onOpenChange={toggle("switcher")} />
      <CommandPalette open={overlay === "palette"} onOpenChange={toggle("palette")} />
      <ShortcutHelp open={overlay === "shortcuts"} onOpenChange={toggle("shortcuts")} />
      <StatusDialogHost />
    </>
  );
}
